import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { ICruiseDetail } from '../../interfaces/icruise-detail';
import { MappingItem } from '../../../../../shared/interfaces/mapping-item';
import { ICruiseDetailExcursion } from '../../interfaces/icruise-detail-excursion';
import { ExcursionPortsPipe } from '../../pipes/excursion-ports.pipe';
@Component({
  selector: 'app-cruise-detail-content-excursions',
  templateUrl: './cruise-detail-content-excursions.component.html',
  styleUrls: ['./cruise-detail-content-excursions.component.scss'],
})
export class CruiseDetailContentExcursionsComponent implements OnInit {
  @Input() cruise$: Observable<ICruiseDetail>;
  selectedHarbour: MappingItem;
  selectedExcursion: ICruiseDetailExcursion;

  allAvailableExcursions: any[] = [];

  config = {
    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: 25,
    breakpoints: {
      320: {
        slidesPerView: 1.25,
        centeredSlides: false,
      },
      992: {
        slidesPerView: 2,
        centeredSlides: false,
      },
      1440: {
        slidesPerView: 3,
        centeredSlides: false,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };
  index;

  constructor(private _excursionPortPipe: ExcursionPortsPipe) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.cruise$ && this.cruise$) {
      this.cruise$.subscribe((e) => {
        this.allAvailableExcursions = [
          ...e.selectedSolution?.excursions,
        ].filter((x) => x); // NB: il filter rimuove eventuali elementi undefined o null
        if (!this.selectedHarbour) {
          this.selectedHarbour = this._excursionPortPipe.transform(
            this.allAvailableExcursions
          )[0];
        }
      });
    }
  }
  ngOnInit(): void {}

  filterBySelectedHarbour = (excursion: ICruiseDetailExcursion) => {
    return excursion.harbour.code === this.selectedHarbour.code;
  };
}
